module.exports = __webpack_public_path__ + "img/bank-035.dabdc90c.png";